import { API } from "./api";

// Applica una favicon dinamica sostituendo (o creando) il link rel="icon".
export function applyFaviconUrl(url) {
  ["icon", "shortcut icon"].forEach((rel) => {
    document.querySelectorAll(`link[rel='${rel}']`).forEach((l) => l.parentNode.removeChild(l));
  });
  const link = document.createElement("link");
  link.rel = "icon";
  link.href = url;
  document.head.appendChild(link);
}

// Legge la favicon della piattaforma (endpoint pubblico) e, se presente, la applica.
export async function loadPlatformFavicon() {
  try {
    const res = await fetch(`${API}/branding`);
    if (!res.ok) return;
    const data = await res.json();
    if (data.has_favicon) {
      applyFaviconUrl(`${API}/branding/favicon?v=${encodeURIComponent(data.updated_at || Date.now())}`);
    }
  } catch {
    /* nessuna favicon personalizzata: resta quella di default */
  }
}
